import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { createFormData } from '../helpers/createFormdata';
import { getApiErrorMessage, toApiError } from '../utils';

export interface UpdateUserPayload {
	id: string;
	name?: string;
	surName?: string;
	email?: string;
	phoneNumber?: string;
	status?: boolean;
	document?: string;
	documentType?: string;
	avatarFile?: File;
}

export const useUpdateUser = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ id, avatarFile, ...data }: UpdateUserPayload) => {
			try {
				const form = createFormData({ ...data, avatar: avatarFile });
				return (await api.put(`/management/user/update/${id}`, form)).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao atualizar usuário');
			}
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: ['users'] });
			queryClient.invalidateQueries({ queryKey: ['userId', variables.id] });
		},
		onError: error => console.error('Erro ao atualizar usuário:', getApiErrorMessage(error, 'Erro ao atualizar usuário')),
	});
};
